import { StatusBar } from "expo-status-bar";
export default function CustomStatusBar() {
  return <StatusBar style="dark" backgroundColor="#fefdf7" />;
}
